import schema, { productSchema, firstStepSchema } from './validator';

import rewardsApi from '../../services/rewardsApi';

export async function fetchAvailableProducts(setAvailableProducts) {
  try {
    const response = await rewardsApi.get('products/available');
    setAvailableProducts(response.data);
  } catch (ex) {
    // Handle exeception
  }
}

export function getProductTransactionTypes(product) {
  const value =
    product?.transaction_type ??
    product?.transactionType ??
    product?.type ??
    product?.transaction_types ??
    product?.types;
  const normalized = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .join(',')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const types = [];
  if (normalized.includes('both') || normalized.includes('ambos')) {
    types.push('credit', 'debit');
  }
  if (normalized.includes('credit') || normalized.includes('credito'))
    types.push('credit');
  if (normalized.includes('debit') || normalized.includes('debito'))
    types.push('debit');
  return [...new Set(types)];
}

export async function validateTransaction(data, setErrors) {
  const errorList = {};
  try {
    await schema.validate(data, { abortEarly: false });
    setErrors({ ...errorList });
    return true;
  } catch (err) {
    err.inner.forEach(error => {
      errorList[error.path] = error.message;
    });
    setErrors({ ...errorList });
    return false;
  }
}

export async function validateFirstStep(data, setErrors) {
  const errorList = {};
  try {
    await firstStepSchema.validate(data, { abortEarly: false });

    if (data.newTransaction) {
      await rewardsApi.get(`user/${data.cpf}`);
    } else {
      await rewardsApi.get(
        `user/${data.cpf}?type=${data.type}&token=${data.token}`
      );
    }

    setErrors({ ...errorList });
    return true;
  } catch (err) {
    if (err.inner)
      err.inner.forEach(error => {
        errorList[error.path] = error.message;
      });

    if (err.response?.data) {
      if (err.response.data?.error) return false;

      err.response.data?.errors?.forEach(error => {
        errorList[error.path] = error.message;
      });
    }

    setErrors({ ...errorList });
    return false;
  }
}

export async function validateProduct(data, setErrors) {
  const errorList = {};
  try {
    await productSchema.validate(data, { abortEarly: false });
    setErrors({ ...errorList });
    return true;
  } catch (err) {
    err.inner.forEach(error => {
      errorList[error.path] = error.message;
    });
    setErrors({ ...errorList });
    return false;
  }
}

export async function handleCreate({ id, ...data }) {
  try {
    const response = await rewardsApi.post('transactions', { ...data });

    return response.data;
  } catch (err) {
    const message = err.response.data[0]
      ? err.response.data[0].message
      : err.response.data.error;
    return { error: message || 'Ocorreu um erro ao criar a transação' };
  }
}

export async function handleCreateByProduct({ id, ...data }) {
  try {
    const response = await rewardsApi.post('transactions/by-product', {
      ...data,
    });

    return response.data;
  } catch (err) {
    const message =
      err.response?.data?.error || 'Ocorreu um erro ao criar a transação';
    return { error: message };
  }
}
